module.exports = __webpack_public_path__ + "static/media/ecommerce.07b76e0a.svg";